import { render, staticRenderFns } from "./HdPage.vue?vue&type=template&id=490e982a&scoped=true"
import script from "./HdPage.vue?vue&type=script&lang=js"
export * from "./HdPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490e982a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('490e982a')) {
      api.createRecord('490e982a', component.options)
    } else {
      api.reload('490e982a', component.options)
    }
    module.hot.accept("./HdPage.vue?vue&type=template&id=490e982a&scoped=true", function () {
      api.rerender('490e982a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/pages/HdPage.vue"
export default component.exports